<template>
    <div class="mobile-page">
        <!--        <div>-->
        <!--            <p>用户：{{ $t('item.username') }}</p>-->
        <!--            <p>密码：{{ $t('item.password') }}</p>-->
        <!--            <p>邮箱：{{ $t('item.email') }}</p>-->
        <!--        </div>-->

        <div class="top">
            <div class="official-web" @click="getOfficialWeb()"></div>
            <div class="shop-title" :style="setTitleBg()"></div>

            <div class="lang">
                <div class="lang-img"></div>
                <el-select class="lang-select" v-model="languageValue" placeholder="请选择" @change="handleSetLanguage">
                    <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                    </el-option>
                </el-select>
            </div>

        </div>


        <div class="content">
            <div class="role-infor" v-loading.fullscreen = "userLoadStatus">
                <div class="role-infor-tit">{{ $t('userForm.title') }}</div>

                <el-form class="role-info-input" :model="userRequest" ref="userRequestForm">
                    <el-form-item
                            prop="userId"
                            :rules="[
                  { required: true, message: $t('userForm.idEmptyRemind')},
                  { type: 'number', message: $t('userForm.idErrorRemind')}]"
                    >
                        <el-input v-model.number="userRequest.userId" maxlength="11" show-word-limit
                                  :placeholder="$t('userForm.id')"></el-input>
                    </el-form-item>

                    <!-- <el-form-item
                            prop="email"
                            :rules="[
                  { required: true, message: $t('userForm.emailEmptyRemind'), trigger: 'blur' },
                  { type: 'email', message: $t('userForm.emailErrorRemind'), trigger: ['blur', 'change'] }]"
                    >
                        <el-input v-model="userRequest.email" maxlength="30" show-word-limit
                                  :placeholder="$t('userForm.email')"></el-input>
                    </el-form-item> -->
                    <!-- <p class="email-tip">{{ $t('userForm.required') }}</p> -->

                    <el-form-item>
                        <el-button type="primary" @click="submitUserRoleForm('userRequestForm')">{{ $t('confirm') }}
                        </el-button>
                    </el-form-item>
                </el-form>

            </div>

            <div class="m-mode-title"> {{ $t('shop.name') }}</div>
            <div class="m-commodity" ref="commodityH" v-loading.fullscreen ="commodityLoadStatus">
                <div class="m-commodity-group" v-for="(groupList, index) in commodityGroupList" :key="index">
                    <div class="little-title"> {{ $t('shop.little' + index) }} </div>
                    <div class="m-shop">
                        <div class="m-commodity-info" v-for="(info, infoIndex) in groupList" :key="infoIndex">
                            <div class="m-tag-num" v-show="info.discount != null">
                                <span>{{info.discount}}%</span>
                            </div>

                            <img class="commodity-image" :src="info.image_url"
                                 @click="submitCommodity(info, index, infoIndex)">
                            <div class="m-price"> CNY{{info.price}}</div>
                            <img class="select" v-if="info.selectStatus"
                                 src="https://mosoga-html.oss-cn-hangzhou.aliyuncs.com/static/greenhat/v2/img/shop/select.png"
                                 alt="">
                            <!-- 商品详情弹窗-->
                            <el-button class="m-detail" type="text" @click="commodityPop(infoIndex, info)">{{ $t('info')
                                }}
                            </el-button>
                        </div>
                    </div>

                </div>
            </div>


            <div class="m-order">
                <div v-if="showOrderContent">
                    <p class="m-order-title">{{ $t('order.summary') }}</p>
                    <div class="m-order-content">
                        <div class="m-order-detail">
                            <span>{{ $t('order.id') }}</span>
                            <span>{{userRole.userId}}</span>
                        </div>
                        <div class="m-order-detail">
                            <span>{{ $t('order.nikeName') }}</span>
                            <span>{{userRole.name}}</span>
                        </div>
                        <div class="m-order-detail">
                            <span>{{ $t('order.productName') }}</span>
                            <span>{{commodityInfo.name}}</span>
                        </div>
                    </div>
                    <div class="m-order-price">
                        CNY: {{commodityInfo.price}}
                    </div>
                </div>

                <div class="order-bottom">
                    <div class="m-order-submit">
                        <div class="amount-currency" >
                            <span >{{ $t('order.paymentAmount') }}:</span>
                            <span class="amount" >{{commodityInfo.price}}</span>
                            <span class="currency" >CNY</span>
                        </div>
                        <!--                        <div>支付金额：68.00 USD</div>-->
                        <div class="el-icon-arrow-up" v-if="!showOrderContent" @click="showOrder(true)"></div>
                        <div class="el-icon-arrow-down" v-if="showOrderContent" @click="showOrder(false)"></div>
                        <el-button type="primary" round @click="paymentConfirmation()" v-loading.fullscreen ="orderLoadStatus">
                            {{ $t('confirm') }}
                        </el-button>
                    </div>

                    <div class="warn" v-if="showOrderContent">
                        {{ $t('order.payWarn') }}
                        <span class="obvious"> {{ $t('order.payObvious') }} </span>
                    </div>
                </div>

            </div>

        </div>
        <div id="footer" class="m-bottom"></div>
        <div class="m-dialog " v-if="centerDialogVisible" @click="closeDia()">
            <div class="m-dia-content" @click="$event.stopPropagation()">
                <p>{{ $t('shop.detail') }}</p>
                <div class="m-dia-commodity">
                    <img :src="currentInfo.image_url" alt="" :class="`img-${currentInfo.sku}`">
                    <div>CNY{{currentInfo.price}}</div>
                    <div>{{currentInfo.description}}</div>
                </div>
                <div class="m-dia-confirm" @click="closeDia()">{{ $t('confirm') }}</div>
            </div>
        </div>

        <!--  支付渠道弹窗    -->
        <el-dialog
                :title="$t('channel.title')"
                :visible.sync="payDialogVisible"
                width="95%"
                center
                :destroy-on-close="true"
                :close-on-click-modal="false"
                custom-class="payment-pop">

            <el-radio-group v-model="radio">
                <el-radio :label="1">微信</el-radio>
                <el-radio :label="2">支付宝</el-radio>
            </el-radio-group>
            <!-- <div class="warn">{{ $t('channel.warn') }}</div> -->

            <span slot="footer" class="dialog-footer">
                <el-button @click="payDialogVisible = false">{{ $t('cancel') }}</el-button>
                <el-button type="primary" @click="createProductOrder()">{{ $t('confirm') }}</el-button>
              </span>
        </el-dialog>


        <!--  微信支付二维码    -->
        <el-dialog
            title="微信扫码支付"
            :visible.sync="wxQRCodeVisible"
            width="95%"
            center
            :destroy-on-close="true"
            :close-on-click-modal="false"
            custom-class="payment-pop">

            <img :src="wxQRCodeURL" width="100%" height="100%"/>

            <p style="color:red;text-align: center;">付款成功后请重启游戏软件</p>
            <p style="color:red;text-align: center">该页面不会自动刷新</p>
        </el-dialog>
    </div>
</template>
<script>
    import mall from '../mall'

    export default {
        name: 'MobileHomeView',
        ...mall
    }
</script>
<style lang="less" scoped>
    @import './index.less';
</style>